import React, { useState } from "react";
import { Button, Grid, FormControl, InputLabel, OutlinedInput, CircularProgress, Typography } from "@material-ui/core";
import { panelUsersAuthStyle } from "../users_auth/panelUsersAuthStyle";
import { useDispatch } from "react-redux";
import { Store } from "react-notifications-component";
import { EMAIL } from "../../app/api-client/constants";
import { ChanguePAss } from "../domain/api/UsersApi";

export const ChanguePass = ({ reload, clearData, closeModal }) => {
    const classes = panelUsersAuthStyle();
    const [isLoanding, setisLoanding] = useState(false);
    const [nuevaContrasena, setNuevaContrasena] = useState("");
    const [confirmarContrasena, setConfirmarContrasena] = useState("");

    const dispath = useDispatch();

    const handledAlert = (title, message, type) => {
        Store.addNotification({
            title: title,
            message: message,
            type: type,
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
                duration: 5000,
                onScreen: true
            }
        });

        
       
        // Cierra la modal al cambiar la contraseña
    };

    const handleVolver = () => {
        clearData();
        setNuevaContrasena("");
        setConfirmarContrasena("");
      };
    const userEmail = localStorage.getItem(EMAIL);


    const cambiarContraseña = async () => {
        if (nuevaContrasena === confirmarContrasena) {
            try {
                const request={
                    to:userEmail,
                    password:nuevaContrasena
                }
                // Aquí va tu lógica para cambiar la contraseña
                const response = await ChanguePAss(dispath,request);
                if (response.code === 'Ex00') {
                    handledAlert("Cambio Exitoso!", "Contraseña cambiada correctamente.", "success");
                    clearData()
                } else {
                    handledAlert("Error", "Ocurrió un error al cambiar la contraseña.", "danger");
                }
            } catch (error) {
                console.error(error);
                handledAlert("Error", "Ocurrió un error inesperado. Intente nuevamente más tarde.", "danger");
            }
        } else {
            handledAlert("Error", "Las contraseñas no coinciden. Deben ser iguales.", "danger");
        }
    };

    return (
        <form>
            <Typography variant="body1" gutterBottom>
                Por favor, diligencia los campos:
            </Typography>
            <Grid container spacing={2} style={{ textAlign: "left" }}>
                <Grid item xs={12} md={6} sm={6}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="nuevaContrasena">Nueva Contraseña</InputLabel>
                        <OutlinedInput
                            id="nuevaContrasena"
                            type="password"
                            name="nuevaContrasena"
                            value={nuevaContrasena}
                            required
                            onChange={(e) => setNuevaContrasena(e.target.value)}
                            labelWidth={140}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} md={6} sm={6}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel htmlFor="confirmarContrasena">Confirmar Contraseña</InputLabel>
                        <OutlinedInput
                            id="confirmarContrasena"
                            type="password"
                            name="confirmarContrasena"
                            value={confirmarContrasena}
                            required
                            onChange={(e) => setConfirmarContrasena(e.target.value)}
                            labelWidth={160}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className={classes.wrapper}>
                <Grid container justifyContent="flex-end" style={{ marginTop: '30px', marginRight: '10%' }}>
                    <Button
                        disabled={!nuevaContrasena || !confirmarContrasena}
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", width: "auto", marginRight: '10px' }}
                        onClick={cambiarContraseña}
                    >
                        Cambiar Contraseña
                    </Button>
                    <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        style={{ textTransform: "none", width: "auto" }}
                        onClick={handleVolver}
                    >
                        Volver
                    </Button>
                </Grid>
                {isLoanding && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
        </form>
    );
};
